export const adminCreateUser = `mutation adminCreateUser($input: UserCreateInput!) {
  adminCreateUser(input: $input) {
      accountId
      userId
      email
      firstName
      lastName
      nickName
      phoneNumber
      language
      active
      isAccountAdmin
      preferences {
        decimalSeparator
        thousandsSeparator
        listSeparator
      }
      parameters
  }
}`;

export const adminUpdateUser = `mutation adminUpdateUser($input: UserUpdateInput!) {
  adminUpdateUser(input: $input) {
      accountId
      userId
      email
      firstName
      lastName
      nickName
      phoneNumber
      language
      active
      isAccountAdmin
      preferences {
        decimalSeparator
        thousandsSeparator
        listSeparator
      }
      parameters
  }
}`;

export const adminDeleteUser = `mutation adminDeleteUser($userId: ID!) {
  adminDeleteUser(userId: $userId) {
      userId
  }
}`;

export const userUpdateUser = `mutation userUpdateUser($input: UserUpdateInput!) {
  userUpdateUser(input: $input) {
      userId
      email
      firstName
      lastName
      nickName
      phoneNumber
      language
      active
  }
}`;
